import(/* webpackMode: "eager", webpackExports: ["BabyDanceView"] */ "/app/apps/frontend/components/baby-dance/view.tsx");
